import instance from "../utils/network";

export function updateUserCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/user-count/${id}?count=${count}`
  );
}

export function updateTimer(
  id: number,
  playTime: number,
  isStop?: boolean,
  type?: string
): Promise<{ code: number; message: any }> {
  const body = {
    playTime,
    isStop,
    type,
  };
  return instance.put(`/seller/tournament/timer/${id}`, body);
}

export function updateTimerTime(
  id: number,
  playTime: number,
  isStop?: boolean,
  type?: string
): Promise<{ code: number; message: any }> {
  const body = {
    playTime,
    isStop,
    type,
  };
  return instance.put(`/seller/tournament/timer/time/${id}`, body);
}

export function createTimer(
  id: number
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/tournament/timer/${id}`);
}

export function removeTimer(
  id: number
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/tournament/timer/${id}`);
}

export function updateEntryUserCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/entry-user-count/${id}?count=${count}`
  );
}

export function updateReBuyInUserCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/re-buy-in-user-count/${id}?count=${count}`
  );
}

export function updateEarlyInChipCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/total-stack/${id}?count=${count}`
  );
}

export function updateTotalStackCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/total-stack/${id}?count=${count}`
  );
}

export function updateAdOnUserCount(
  id: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/add-on-user-count/${id}?count=${count}`
  );
}

export function setTournamentLastLevel(
  timerId: number
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/timer/last-level/${timerId}`);
}

export function setTournamentFirstLevel(
  timerId: number
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/timer/first-level/${timerId}`);
}

export function setTournamentLevel(
  timerId: number,
  structureId: number
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/timer/enter-level`, {
    timerId,
    structureId,
  });
}

export function setTournamentLevelTime(
  timerId: number,
  structureId: number,
  time: number
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/tournament/timer/enter-time`, {
    timerId,
    structureId,
    time,
  });
}

export function setTournamentUserCount(
  tournamentId: number,
  count: number
): Promise<{ code: number; message: any }> {
  return instance.patch(
    `/seller/tournament/timer/user-count-input/${tournamentId}?count=${count}`
  );
}
